export const companies = "companies";
export const employees = "employees";
export const users = "users";



// WEBPACK FOOTER //
// ./src/interfaces/collections.ts